import Error404 from './pages/ErrorPages/pages-404';
import Displayboard from './pages/DisplayBoard/Container/Displayboard';

const routes = [
    { path: '/', component: Displayboard },

    { path: '*', component: Error404 },

];

export default routes;